import { rgba } from 'polished';
import { mapValues } from 'radash';
import '../tokens/border-radiuses.js';
import { colorAlphas } from '../tokens/color-alphas.js';
import { colors } from '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * Collection of base fills as foundational surface tones. In light mode, tones utilize a consistent
 * white, relying on shadows and outlines for visual hierarchy. Dark mode uses varied opacities for
 * depth.
 */ const baseFillColors = {
    light: {
        none: 'transparent',
        soft: 'white',
        medium: 'white',
        bold: 'white'
    },
    dark: {
        none: 'transparent',
        soft: rgba('white', colorAlphas.weak),
        medium: rgba('white', colorAlphas.medium),
        bold: rgba('white', colorAlphas.strong)
    }
};
/**
 * Collection of alias tokens for fill colors. Unlike background colors, these are tailored for
 * surfaces. The gray tone is adjusted for contrast in light mode and aligns with base fills in dark
 * mode.
 */ const fillColorAliases = {
    light: {
        base: baseFillColors.light,
        ...mapValues(colors, (color)=>({
                none: 'transparent',
                soft: rgba(color[500], colorAlphas.weak),
                medium: gradient(color[700], color[800]),
                bold: gradient(color[500], color[600])
            })),
        gray: {
            none: 'transparent',
            soft: rgba(colors.gray[500], colorAlphas.weak),
            medium: gradient(colors.gray[700], colors.gray[800]),
            bold: gradient(colors.gray[800], colors.gray[900])
        }
    },
    dark: {
        base: baseFillColors.dark,
        ...mapValues(colors, (color)=>({
                none: 'transparent',
                soft: rgba(color[400], colorAlphas.medium),
                medium: gradient(color[600], color[800]),
                bold: gradient(color[500], color[600])
            })),
        gray: baseFillColors.dark
    }
};
/**
 * Returns a linear gradient CSS between given start and end colors.
 *
 * @param start - Starting color of the gradient.
 * @param end - Ending color of the gradient.
 */ function gradient(start, end) {
    return `linear-gradient(to bottom right, ${start}, ${end} 100%)`;
}

export { fillColorAliases };
//# sourceMappingURL=fill-colors.js.map
